module.exports = __webpack_public_path__ + "52be6e629eb363fdfc21d0ff43985d70.jpg";